module.exports = __webpack_public_path__ + "res/34-img_media_bg.40e8370949d7101b3d475e91d062353e.png";